import { connect } from 'react-redux';
import { push } from 'redux-first-history';

import { modalClose } from '@app/store/modal/actions';

import { BasicModal } from '../../components/Modal';

function EditorSingleCompleteModal(props) {
  return <BasicModal {...props} />;
}

const mapDispatchToProps = (dispatch) => ({
  onClose: () => {
    dispatch(modalClose());
    dispatch(push('/editing-documents'));
  },
});

export default connect(undefined, mapDispatchToProps)(EditorSingleCompleteModal);
